import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, FlexBox, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import styles from './analyticsMenu.module.scss';
export const AnalyticsMenu = ({ actions, direction, dropdownButtonProps = {}, }) => {
    var _a, _b;
    if (!actions.length)
        return null;
    const renderAction = (action, index, callback) => {
        var _a;
        switch (action.type) {
            case 'action':
                return (_jsx(Tooltip, Object.assign({ className: styles.tooltip, content: action.tooltip, dark: true }, { children: _jsx(ButtonList.Item, Object.assign({ icon: action.icon, onClick: () => {
                            action.onClick();
                            callback();
                        }, isDisabled: (_a = action.disabled) !== null && _a !== void 0 ? _a : false }, { children: _jsxs(FlexBox, Object.assign({ as: "span", flexDirection: "column", alignItems: "flex-start", gap: "2px" }, { children: [_jsx("span", { children: action.label }), action.description && (_jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4", subdued: true }, { children: action.description })))] })) })) }), index));
            case 'divider':
                return _jsx(ButtonList.Divider, {}, index);
            default:
                return null;
        }
    };
    // Override the automatic positioning calculated by the Dropdown component, which doesn't always
    // work as expected because the dropdown may be rendered inside a transformed container. These
    // values position the dropdown in the bottom right or bottom left side of the button.
    const dropdownPositionOverride = direction
        ? {
            top: '100%',
            bottom: 'auto',
            right: direction === 'left' ? 0 : 'auto',
            left: direction === 'left' ? 'auto' : 0,
            margin: `${sizes.spacer[200]} 0 0 0`,
        }
        : {};
    return (_jsx(DropdownButton, Object.assign({ icon: "dots-v", dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: actions.map((action, index) => renderAction(action, index, toggleDropdown)) })) }), dropdownProps: Object.assign(Object.assign({}, ((_a = dropdownButtonProps.dropdownProps) !== null && _a !== void 0 ? _a : {})), { style: Object.assign({}, dropdownPositionOverride) }), buttonProps: Object.assign(Object.assign({}, ((_b = dropdownButtonProps.buttonProps) !== null && _b !== void 0 ? _b : {})), { variant: 'tertiary' }), noArrow: true }, dropdownButtonProps)));
};
